import { observable } from 'mobx';
import { HttpClient } from './HttpClient';

export class CommonAppStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @observable
    public headerHeight: number | null = null;

    @observable
    public titleContainer: HTMLDivElement | null = null;

    @observable
    public subTopbarContainer: HTMLDivElement | null = null;

    @observable
    public loadGoogleMaps = false;

    @observable
    public googleMapsLoaded = false;

    @observable
    public liveChartStaticScaling = true;

    @observable
    public chartHasDataOutOfBounds = false;

    private readonly httpClient: HttpClient;
}
